import ElevatorIntegrationSwitchSettings from './ElevatorIntegrationSwitchSettings';

export default ElevatorIntegrationSwitchSettings;
